import React from 'react';

function Icon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="234" height="333" version="1.1">
            <g transform="translate(0 -719.362)">
                <g>
                    <rect
                        width="233.244"
                        height="332.244"
                        x="0.378"
                        y="719.74"
                        fill="#fff"
                        fillOpacity="1"
                        stroke="gray"
                        strokeDasharray="none"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeMiterlimit="4"
                        strokeOpacity="1"
                        strokeWidth="0.756"
                        rx="8.919"
                        ry="8.946"
                    ></rect>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M45.71 880.825c0-1.669-.093-2.874-.093-4.542h10.634v-8.211c-6.732.217-14.017.717-20.321-2.061-4.88-2.678-6.227-8.913-5.243-14.038.842-5.783 4.057-10.918 8.25-14.873 5.458-5.837 12.418-9.778 19.684-12.949 7.417 3.225 14.53 7.294 20.057 13.285 4.978 4.678 8.295 11.29 8.193 18.212.108 4.997-2.987 10.277-8.093 11.367-5.71 1.581-11.49 1.3-17.354 1.057v8.211h10.058c0 1.668.093 2.873.093 4.542-7.897-.056-17.336-.056-25.866 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M45.71 890.9c0 1.668-.093 2.873-.093 4.541h10.634v8.211c-6.732-.216-14.017-.716-20.321 2.061-4.88 2.679-6.227 8.913-5.243 14.038.842 5.783 4.057 10.918 8.25 14.873 5.458 5.838 12.418 9.778 19.684 12.949 7.417-3.224 14.53-7.294 20.057-13.285 4.978-4.678 8.295-11.29 8.193-18.212.108-4.996-2.987-10.276-8.093-11.367-5.71-1.581-11.49-1.3-17.354-1.057v-8.211h10.058c0-1.668.093-2.873.093-4.541-7.897.055-17.336.055-25.866 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M162.45 880.825c0-1.669-.092-2.874-.092-4.542h10.634v-8.211c-6.732.217-14.018.717-20.322-2.061-4.88-2.678-6.226-8.913-5.242-14.038.842-5.783 4.056-10.918 8.25-14.873 5.458-5.837 12.417-9.778 19.684-12.949 7.417 3.225 14.53 7.294 20.057 13.285 4.978 4.678 8.294 11.29 8.192 18.212.108 4.997-2.987 10.277-8.092 11.367-5.711 1.581-11.491 1.3-17.354 1.057v8.211h10.058c0 1.668.092 2.873.092 4.542-7.896-.056-17.336-.056-25.865 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M162.45 814.076c0-1.668-.092-2.873-.092-4.541h10.634v-8.211c-6.732.216-14.018.716-20.322-2.061-4.88-2.679-6.226-8.913-5.242-14.038.842-5.783 4.056-10.918 8.25-14.873 5.458-5.838 12.417-9.778 19.684-12.949 7.417 3.224 14.53 7.294 20.057 13.285 4.978 4.678 8.294 11.29 8.192 18.212.108 4.996-2.987 10.276-8.092 11.367-5.711 1.581-11.491 1.3-17.354 1.057v8.211h10.058c0 1.668.092 2.873.092 4.541-7.896-.055-17.336-.055-25.865 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M45.71 814.076c0-1.668-.093-2.873-.093-4.541h10.634v-8.211c-6.732.216-14.017.716-20.321-2.061-4.88-2.679-6.227-8.913-5.243-14.038.842-5.783 4.057-10.918 8.25-14.873 5.458-5.838 12.418-9.778 19.684-12.949 7.417 3.224 14.53 7.294 20.057 13.285 4.978 4.678 8.295 11.29 8.193 18.212.108 4.996-2.987 10.276-8.093 11.367-5.71 1.581-11.49 1.3-17.354 1.057v8.211h10.058c0 1.668.093 2.873.093 4.541-7.897-.055-17.336-.055-25.866 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M104.08 914.199c0-1.669-.093-2.873-.093-4.542h10.635v-8.211c-6.732.217-14.018.717-20.322-2.061-4.88-2.678-6.227-8.913-5.243-14.038.842-5.783 4.057-10.918 8.25-14.873 5.458-5.837 12.418-9.778 19.684-12.948 7.417 3.224 14.53 7.293 20.057 13.285 4.978 4.678 8.295 11.29 8.193 18.211.108 4.997-2.987 10.277-8.092 11.367-5.711 1.582-11.492 1.301-17.354 1.057v8.211h10.058c0 1.669.092 2.873.092 4.542-7.897-.056-17.336-.056-25.865 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M12.899 780.702c0-.556-.031-.958-.031-1.514h3.545v-2.737c-2.244.072-4.673.24-6.774-.687-1.627-.893-2.076-2.97-1.748-4.68.281-1.927 1.353-3.638 2.75-4.957 1.82-1.946 4.14-3.26 6.562-4.316 2.472 1.075 4.843 2.431 6.685 4.428 1.66 1.56 2.765 3.764 2.731 6.071.036 1.665-.995 3.425-2.697 3.789-1.904.527-3.83.434-5.785.352v2.737h3.353c0 .556.03.958.03 1.514a669.463 669.463 0 00-8.621 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M45.71 957.648c0 1.668-.093 2.873-.093 4.541h10.634v8.212c-6.732-.217-14.017-.717-20.321 2.06-4.88 2.679-6.227 8.913-5.243 14.039.842 5.782 4.057 10.918 8.25 14.873 5.458 5.837 12.418 9.778 19.684 12.948 7.417-3.224 14.53-7.294 20.057-13.285 4.978-4.678 8.295-11.29 8.193-18.212.108-4.996-2.987-10.276-8.093-11.366-5.71-1.582-11.49-1.301-17.354-1.057v-8.212h10.058c0-1.668.093-2.873.093-4.54-7.897.055-17.336.055-25.866 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M162.45 957.648c0 1.668-.092 2.873-.092 4.541h10.634v8.212c-6.732-.217-14.018-.717-20.322 2.06-4.88 2.679-6.226 8.913-5.242 14.039.842 5.782 4.056 10.918 8.25 14.873 5.458 5.837 12.417 9.777 19.684 12.948 7.417-3.224 14.53-7.294 20.057-13.285 4.977-4.678 8.294-11.29 8.192-18.212.108-4.996-2.987-10.276-8.092-11.366-5.711-1.582-11.491-1.301-17.354-1.057v-8.212h10.058c0-1.668.092-2.873.092-4.54-7.897.055-17.336.055-25.865 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M162.45 890.9c0 1.668-.092 2.873-.092 4.541h10.634v8.211c-6.732-.216-14.017-.716-20.322 2.061-4.88 2.679-6.226 8.913-5.242 14.038.842 5.783 4.057 10.918 8.25 14.873 5.458 5.838 12.417 9.778 19.684 12.949 7.417-3.224 14.53-7.294 20.057-13.285 4.978-4.678 8.294-11.29 8.192-18.212.108-4.996-2.987-10.276-8.092-11.367-5.71-1.581-11.491-1.3-17.354-1.057v-8.211h10.058c0-1.668.092-2.873.092-4.541-7.896.055-17.335.055-25.865 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M212.488 991.022c0 .556-.031.958-.031 1.514h3.545v2.737c-2.244-.072-4.673-.239-6.774.687-1.627.893-2.076 2.971-1.748 4.68.28 1.927 1.352 3.639 2.75 4.957 1.82 1.946 4.14 3.26 6.562 4.316 2.472-1.075 4.843-2.431 6.685-4.428 1.66-1.56 2.765-3.763 2.731-6.07.036-1.666-.996-3.426-2.697-3.79-1.904-.527-3.83-.433-5.785-.352v-2.737h3.353c0-.556.03-.958.03-1.514-2.632.019-5.778.019-8.621 0z"
                    ></path>
                    <path
                        d="M26.62 740.93q0 6.046-2.105 9.832-2.635 4.752-8.115 4.752-3.205 0-5.29-1.294-2.523-1.584-2.523-4.675 0-.676.93-.676h2.806q.55 0 .929.638.569.946.872 1.217.778.637 2.276.637 2.522 0 3.925-2.395 1.1-1.932 1.232-4.752-2.218 1.797-5.309 1.797-3.925 0-6.257-2.82-2.2-2.647-2.2-6.722 0-4.289 2.408-6.78 2.408-2.511 6.599-2.511 9.822 0 9.822 13.752zm-5.176-4.346q0-2.105-1.12-3.573-1.232-1.623-3.223-1.623-2.048 0-3.261 1.584-1.1 1.449-1.1 3.612 0 2.202 1.08 3.632 1.177 1.564 3.281 1.564 2.086 0 3.262-1.583 1.08-1.43 1.08-3.613z"
                        style={{ lineHeight: '1.25' }}
                        fill="#000"
                        fillOpacity="1"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="39.195"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        wordSpacing="0"
                    ></path>
                    <path
                        d="M207.38 1030.794q0-6.046 2.105-9.832 2.635-4.752 8.115-4.752 3.205 0 5.29 1.294 2.523 1.584 2.523 4.675 0 .676-.93.676h-2.806q-.55 0-.929-.638-.569-.946-.872-1.216-.778-.638-2.276-.638-2.522 0-3.925 2.395-1.1 1.932-1.232 4.752 2.218-1.796 5.309-1.796 3.925 0 6.257 2.82 2.2 2.646 2.2 6.722 0 4.288-2.408 6.78-2.408 2.51-6.599 2.51-9.822 0-9.822-13.752zm5.176 4.346q0 2.105 1.12 3.573 1.232 1.623 3.223 1.623 2.048 0 3.261-1.584 1.1-1.449 1.1-3.612 0-2.202-1.08-3.632-1.176-1.564-3.281-1.564-2.086 0-3.262 1.584-1.08 1.43-1.08 3.612z"
                        style={{ lineHeight: '1.25' }}
                        fill="#000"
                        fillOpacity="1"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="39.195"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        wordSpacing="0"
                    ></path>
                </g>
            </g>
        </svg>
    );
}

export default Icon;
